<div>
    <app-table-component
        [data]="pricingPlansList()"
        [columns]="tableColumns"
        [totalRecords]="totalRecords()"
        [rows]="rows"
        [first]="first"
        (pageChange)="onPageChange($event)"
        [showColumnSelector]="false"
        [showClearFilters]="false"
        [searchControl]="searchControl" />
</div>

